import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ColourIcon } from 'assets/icon-colour.svg';

const Title = ({ color }) => {
  const { t } = useTranslation();
  return (
    <Container borderBottomColor={color}>
      <ColourIcon fill={color} width={35} height={35} />
      <CustomLabel className="headline" color={color}>
        {t('general_customizer_title')}
      </CustomLabel>
    </Container>
  );
};

const Container = styled.div(({ borderBottomColor }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingBottom: '12px',
  borderBottomWidth: 1,
  borderBottomColor,
  borderBottomStyle: 'solid',
  width: '100%',
}));

const CustomLabel = styled.h1`
  text-transform: uppercase;
  margin-left: 11px;
  color: ${({ color }) => `${color} !important`};
`;

Title.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Title;
